import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface SetGuestEmailOnCartMutationObject {
  mutation: {
    setGuestEmailOnCart: {
      __args: {
        input: {
          cart_id: string
          email: string
          [key: string]: any
        }
      }
      cart: {
        email: boolean
        [key: string]: any
      }
      [key: string]: any
    }
  }
}

export const setGuestEmailOnCartMutationObject: SetGuestEmailOnCartMutationObject = {
  mutation: {
    setGuestEmailOnCart: {
      __args: {
        input: {
          cart_id: '',
          email: ''
        }
      },
      cart: {
        email: true
      }
    }
  }
}

interface SetGuestEmailOnCartMutationInput {
  cartId: string
  email: string
}

export type SetGuestEmailOnCartMutation = (input: SetGuestEmailOnCartMutationInput) => Promise<FetchResult<any>>

export const createSetGuestEmailOnCartMutation = ({ getMutations }: ServiceDependencies): SetGuestEmailOnCartMutation => async ({ cartId, email }) => {
  const mutation = getMutations().setGuestEmailOnCartMutation
  mutation.mutation.setGuestEmailOnCart.__args.input.cart_id = cartId
  mutation.mutation.setGuestEmailOnCart.__args.input.email = email

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
